import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Mailing_Service, SuccessAccount_Service, SuccessAccount } from '../../index';
import { MatDialog } from '@angular/material/dialog';
import { SsoRequireAccountSetUpWarningComponent } from '../ssoRequireAccountSetUpWarning/ssoRequireAccountSetUpWarning.component';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {
  public isFLNAPIerror: boolean = false;
  public isSSOerror: boolean = false;
  public invalidToken: boolean = false;
  public directLoginBlock: boolean = false;
  public ssoSource: string = '';
  public errorMessage: string = '';
  public serviceReported: string = '';
  public errorArray: Array<string> = [];
  public username: string = '';

  constructor( 
    private dialog: MatDialog,
    private mailingService: Mailing_Service,
    private successAccountService: SuccessAccount_Service,
    public oidcService: OidcSecurityService,
    public route: ActivatedRoute) { }

  ngOnInit(): void {
    // can't seem to figure out how to get the error message that is sent in the redirect uri
    // just going to just show a generic error message here.

    // this.oidcService.stsCallback$.subscribe(what => {
    //   this.what = what;
    // })
    // this.route.queryParams.pipe(
    //   filter(params => 'error' in params)
    // ).subscribe(params => {
    //     this.params = params;
    // })

    if(window.localStorage.getItem('error')) {
      this.errorMessage = window.localStorage.getItem('error') as string;
      this.errorMessage = decodeURIComponent(this.errorMessage);
      console.debug('unauthorized: errorMessage:', this.errorMessage);

      this.errorMessage = this.errorMessage.slice(this.errorMessage.indexOf('&error_description='), this.errorMessage.indexOf('&state='))
      this.directLoginBlock = this.errorMessage.includes('DirectLoginViolation');
      this.isFLNAPIerror = this.errorMessage.includes('FLNAPI');
      this.isSSOerror = this.errorMessage.includes('user not matched');
      this.errorMessage = this.errorMessage.slice(this.errorMessage.indexOf('=')+1).trim();
      if(this.errorMessage.indexOf('Service reported:') != -1) {
        this.serviceReported = this.errorMessage.slice(this.errorMessage.indexOf('Service reported:'));
        this.errorMessage = this.errorMessage.slice(0, this.errorMessage.indexOf('Service reported:'));
      }

      if(this.isSSOerror) {
        let username = decodeURIComponent(this.errorMessage);
        if(this.errorMessage.indexOf(' user not matched'))
          this.ssoSource = this.errorMessage.slice(0, this.errorMessage.indexOf(' user not matched'));
        console.debug('unauthorized: sso source:', this.ssoSource);
        this.username = username.slice(username.lastIndexOf(':')+1);
        console.debug('unauthorized: send warning to support for user:', this.username);
        this.successAccountService.getSuccessAccountByEmail({email:this.username}).subscribe((successAccount: SuccessAccount)=>{
          if(this.username && successAccount.email != this.username) {
            this.mailingService.sendSSOUserWarning(this.username, this.ssoSource).subscribe(()=>{});
            this.dialog.open(SsoRequireAccountSetUpWarningComponent, {
              data: {ssoSource: this.ssoSource, username: this.username}
            }).afterClosed();
          }
        })
      }

      window.localStorage.removeItem('error');
    }

    if(window.localStorage.getItem('saml_error') || window.localStorage.getItem('okta_error')) {
      this.isSSOerror = true;
      this.invalidToken = true;
      
      if(window.localStorage.getItem('saml_error')) {
        this.errorArray = (window.localStorage.getItem('saml_error') as string).split(';');
        if(!this.ssoSource) this.ssoSource = 'Azure Entra';
        window.localStorage.removeItem('saml_error');
      }

      if(window.localStorage.getItem('okta_error')) {
        this.errorArray = (window.localStorage.getItem('okta_error') as string).split(';');
        if(!this.ssoSource) this.ssoSource = 'Okta';
        window.localStorage.removeItem('okta_error');
      }
      
      this.errorArray = this.errorArray.map((entry) => { return entry.trim(); });
      console.debug('unauthorized: errorArray:', this.errorArray);
    }
  }

  retry() {
    this.oidcService.authorize();
  }

}
